<template>
  <footer class="shell-footer">
    <v-sheet color="primary darken-1" class="position-relative">
      <v-container class="py-6">
        <v-row justify="space-between">
          <v-col cols="12" md="4" lg="3">
            <div>
              <div class="font-weight-medium text-h6 text-sm-h5 white--text">
                <span class="font-bazinga filter-shadow"
                  >Contato para Shows</span
                >
              </div>
              <v-btn
                v-if="phone"
                class="text-h6 ml-n4 mt-1"
                color="white"
                text
                depressed
                :href="phone"
              >
                <div class="d-flex align-center">
                  <v-icon size="20">fas fa-phone-alt</v-icon>
                  <span class="font-bazinga ml-2">{{ informations.tel }}</span>
                </div>
              </v-btn>
              <v-btn
                v-if="whatsapp"
                class="text-h6 ml-n4 mt-1"
                color="white"
                text
                depressed
                :href="whatsapp"
              >
                <div class="d-flex align-center">
                  <v-icon size="22">fa-whatsapp</v-icon>
                  <span class="font-bazinga ml-2">{{
                    informations.whatsapp
                  }}</span>
                </div>
              </v-btn>
            </div>
          </v-col>
          <v-col cols="12" md="5" lg="4">
            <div
              class="
                font-weight-medium
                text-h6 text-sm-h5
                white--text
                filter-shadow
              "
            >
              <span class="font-bazinga">Imagens para Download</span>
            </div>
            <div class="donwload-images-container d-flex mt-2">
              <template v-for="(item, i) in imagesList">
                <ImagesDownloadCard :key="i" v-bind="item" />
              </template>
            </div>
          </v-col>
          <v-col cols="12" md="2"
            ><div class="d-flex justify-center justify-md-end align-center">
              <div
                v-for="({ text, link, icon, size }, keySocial) in social"
                :key="keySocial"
                class="d-inline-flex"
              >
                <v-btn
                  class="text-caption text-lg-body-1 ml-2 filter-shadow"
                  :href="link"
                  :title="text"
                  target="_blank"
                  min-width="auto"
                  color="white"
                  small
                  depressed
                  rounded
                  fab
                >
                  <v-icon color="primary" :size="size">{{ icon }}</v-icon>
                </v-btn>
              </div>
            </div></v-col
          >
        </v-row>
      </v-container>
    </v-sheet>

    <v-sheet color="primary darken-1">
      <v-container
        class="
          pt-0
          pb-5
          d-flex
          flex-column flex-sm-row
          justify-space-between
          align-center
          text-center
        "
      >
        <div class="white--text mt-5 font-weight-bold">
          <span class="font-barlow"> {{ informations.name }} © 2023 </span>
          <span class="d-block d-sm-inline-block font-barlow">
            Todos os direitos reservados.
          </span>
        </div>
        <a
          class="d-flex mt-5"
          href="https://www.mrxweb.com.br/"
          target="_blank"
        >
          <img
            class="shell-footer-logo"
            src="../../assets/img/mrxweb.svg"
            alt="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
            title="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
            height="20px"
          />
        </a>
      </v-container>
    </v-sheet>
  </footer>
</template>

<script>
import { getSocial } from "../../utils/getSocial";
import { getTelLinkFromPhone } from "../../utils/getTelLinkFromPhone";
import { getWhatsappLinkFromPhone } from "../../utils/getWhatsappLinkFromPhone";
import ImagesDownloadCard from "../cards/ImagesDownloadCard.vue";

export default {
  data: () => ({
    year: new Date().getFullYear(),
    imagesList: [],
    loading: false,
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    phone() {
      return this.informations.tel
        ? getTelLinkFromPhone(this.informations.tel)
        : null;
    },
    whatsapp() {
      return this.informations.whatsapp
        ? getWhatsappLinkFromPhone(this.informations.whatsapp)
        : null;
    },
    social() {
      return getSocial(this.informations);
    },
  },
  methods: {
    getImagesList() {
      this.loading = true;
      this.$rest("images-download")
        .get()
        .then(({ img: { list } }) => {
          const maxImages = list.slice(-6);
          this.imagesList = maxImages.map(({ id, path, title }) => ({
            id,
            title: title ? title : "Imagem",
            img: this.files + path,
          }));
        })
        .finally(() => (this.loading = false));
    },
  },
  created() {
    this.getImagesList();
  },
  components: { ImagesDownloadCard },
};
</script>

<style lang="scss" scoped>
.donwload-images-container {
  gap: 8px;
  flex-wrap: wrap;
}
.filter-shadow {
  filter: drop-shadow(2px 2px 0px rgba(0, 0, 0, 0.25));
}
</style>
